import { useIntl } from '@/intl'
import { useAnalytics } from '@/scopes/common/infrastructure/analytics/hooks'
import { createPDPClickEvent } from '@/scopes/products/infrastructure/analytics'
import { stripHtmlTags } from '@/scopes/products/pages/components/Description/utils'
import { space, tokPx } from '@sunwebgroup/ui-components'
import { Button, focusOutline, RichText, Sheet, useBreakpoints } from '@sunwebgroup/ui-components/uds'
import * as React from 'react'
import { styled } from 'styled-components'

const TextTruncate = styled.div`
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
  max-width: ${tokPx('primitives_area_size_720')};
  min-width: ${tokPx('primitives_area_size_240')};
  margin-top: ${space('primitives_space_16')};
`

const SheetContent = styled(Sheet.Content)`
  a {
    ${focusOutline()}
  }
`

export function ReadMore({ content }: { content: string }) {
  const [isSheetOpen, setSheetOpen] = React.useState(false)
  const intl = useIntl()
  const { isTabletOrGreater } = useBreakpoints()
  const { sendEvent } = useAnalytics()

  const handleOpenChange = (open: boolean) => {
    setSheetOpen(open)

    if (open) {
      sendEvent(
        createPDPClickEvent({
          element: 'Clickable text',
          description: 'Show more text about acco info',
          result: 'all acco info shown',
          type: 'show more',
        }),
      )
    }
  }

  return (
    <>
      <TextTruncate>
        <RichText innerHTML={stripHtmlTags(content)} />
      </TextTruncate>
      <Sheet.Root open={isSheetOpen} onOpenChange={handleOpenChange}>
        <Sheet.Trigger>
          <Button size="M" variant="transparentPrimary">
            {intl.formatMessage({ id: 'description_read_more' })}
          </Button>
        </Sheet.Trigger>
        <Sheet.Body side={isTabletOrGreater ? 'right' : 'bottom'}>
          <Sheet.Header
            closeLabel={intl.formatMessage({ id: 'close' })}
            titleLabel={intl.formatMessage({ id: 'about_accommodation_title' })}
          />
          <SheetContent>
            <RichText innerHTML={content} />
          </SheetContent>
        </Sheet.Body>
      </Sheet.Root>
    </>
  )
}
